import chatbotImage from '/src/assets/recommenderImage2.png';
import currentPoint from '/src/assets/currentPoint.svg';
import currentSelectPoint from '/src/assets/currentSelectPoint.svg';
import ArrowToRight from '/src/assets/arrowToRight.svg';
import { CHATBOT_CHAT_MSJ_FROM_CLIENT, CHATBOT_MODE_RECOMMENDER } from '../utils/constants.js';
import { useState } from 'preact/hooks';
import isValidLinkedinUrlChatbot from '../utils/chatbotRecommenderUtils.js';


export default function ScreenInputLinkedinChatbot({sendNavigationChange, sendMessage}) {
    const [inputValue, setInputValue] = useState('');
    const onInput = e => {
        setInputValue(e.currentTarget.value);
    };
    const onEnterSubmit = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault(); // Prevent the default behavior (adding a line break)
            onSubmit(e); // Call the onSubmit function
        }
    }
    const onSubmit = e => {
        e.preventDefault();
        const toEvaluate = inputValue.trim();
        if (!toEvaluate || toEvaluate === '') {
            sendNavigationChange();
            return;
        }
        if (!isValidLinkedinUrlChatbot(toEvaluate)){
            alert('Por favor, ingrese un enlace de perfil de Linkedin válido');
            setInputValue('');
            return;
        }

        sendNavigationChange();
        sendMessage({
            from: CHATBOT_CHAT_MSJ_FROM_CLIENT,
            message: toEvaluate,
            typeMode: CHATBOT_MODE_RECOMMENDER
        });
    };

    return <div className="bot-utn-recommender-2">
        <img className="bot-utn-screen-input-linkedin-image" width={200} height={200} src={chatbotImage} alt="recommender-logo"/>
        <div className="bot-utn-screen-input-linkedin-index-points">
            <img className="bot-utn-screen-input-linkedin-point" src={currentPoint} alt="recommender-point"/>
            <img className="bot-utn-screen-input-linkedin-point-line" src={currentSelectPoint} alt="current recommender-point"/>
        </div>
        <h1 className="bot-utn-screen-input-linkedin-h1">
            Ingresa tu Linkedin
        </h1>
        <p className="bot-utn-screen-input-linkedin-p">
            Para conocerte mejor y poder recomendarte de manera más precisa, te recomendamos que ingreses tu perfil de LinkedIn. Si prefieres, puedes omitir este paso.
        </p>
        <label className="bot-utn-screen-input-linkedin-label">
            <p>URL de perfil de Linkedin</p>
            <div className="bot-utn-screen-input-linkedin-div">
                <input
                  className="bot-utn-screen-input-linkedin-input"
                  type="text"
                  placeholder="Insertar enlace aquí..."
                  onInput={onInput}
                  onKeyPress={onEnterSubmit}
                  value={inputValue}
                />
                <button
                    className="bot-utn-screen-input-linkedin-input-button"
                    onClick={onSubmit}
                >
                    <img src={ArrowToRight} alt="enter button linkedin"/>
                </button>
            </div>
        </label>
        <button onClick={() => sendNavigationChange(true)} className="bot-utn-screen-input-linkedin-button">
            Omitir &gt;
        </button>
    </div>
}
